export const translations = {
  CALENDAR_NAVIGATION: {
    en: 'Calendar',
    sv: 'Kalender',
    da: 'Kalender',
    fi: 'Kalenteri',
    no: 'Kalender',
  },
  NEXT_YEAR: {
    en: 'Scroll forward',
    sv: 'Bläddra framåt',
    da: 'Rul frem',
    fi: 'Vieritä eteenpäin',
    no: 'Rull fremover',
  },
  PREVIOUS_YEAR: {
    en: 'Scroll backwards',
    sv: 'Bläddra bakåt',
    da: 'Rul baglæns',
    fi: 'Vieritä taaksepäin',
    no: 'Bla bakover',
  },
  NEXT_DATE: {
    en: 'Next month',
    sv: 'Nästa månad',
    da: 'Næste måned',
    fi: 'Ensi kuussa',
    no: 'Neste måned',
  },
  PREVIOUS_DATE: {
    en: 'Previous month',
    sv: 'Föregående månad',
    da: 'Forrige måned',
    fi: 'Edellinen kuukausi',
    no: 'Forrige måned',
  },
  SELECT_YEAR: {
    en: 'Choose year',
    sv: 'Välj år',
    da: 'Vælg år',
    fi: 'Valitse vuosi',
    no: 'Velg år',
  },
  SELECT_MONTH: {
    en: 'Choose month',
    sv: 'Välj månad',
    da: 'Vælg måned',
    fi: 'Valitse kuukausi',
    no: 'Velg måned',
  },
  SELECT_DATE: {
    en: 'Choose date',
    sv: 'Välj datum',
    da: 'Vælg dato',
    fi: 'Valitse päivämäärä',
    no: 'Velg dato',
  },
  SELECTED_DATE: {
    en: 'selected date is {date}.',
    sv: 'valt datum är {date}.',
    da: 'den valgte dato er {date}.',
    fi: 'valittu päivämäärä on {date}.',
    no: 'valgt dato er {date}.',
  },
  SELECTED_START_DATE: {
    en: 'selected start date is {date}.',
    sv: 'valt startdatum är {date}.',
    da: 'den valgte startdato er {date}.',
    fi: 'valittu aloituspäivä on {date}.',
    no: 'valgt startdato er {date}.',
  },
  SELECTED_END_DATE: {
    en: 'selected end date is {date}.',
    sv: 'valt slutdatum är {date}.',
    da: 'den valgte slutdato er {date}.',
    fi: 'valittu lopetuspäivä on {date}.',
    no: 'valgt sluttdato er {date}.',
  },
  WEEK_NAME: {
    en: 'Week',
    sv: 'Vecka',
    da: 'Uge',
    fi: 'Viikko',
    no: 'Uke',
  },
  GO_CALENDAR: {
    en: 'Calendar view',
    sv: 'Kalendervyn',
    da: 'Kalendervisning',
    fi: 'Kalenterinäkymä',
    no: 'Kalendervisning',
  },
};
